import { useHead, useJsonld } from '#imports'
import type { ISeo } from '~/api/types/response'

export default function useSeo() {
  const route = useRoute()
  const title = `註冊會員 | ${import.meta.env.VITE_WEBSITE_TITLE}`
  const description = ''
  const image = ''
  const url = `${import.meta.env.VITE_APP_BASE_URL}${route.path}`

  useSeoMeta({
    title: title,
    ogTitle: title,
    twitterTitle: title,
    description: description,
    ogDescription: description,
    twitterDescription: description,
    ogImage: image,
    twitterImage: image
    // keywords: (seo?.meta_keywords || []).join(',')
  })

  useHead({
    link: [
      {
        rel: 'canonical',
        href: url
      }
    ]
  })

  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: import.meta.env.VITE_APP_BASE_URL
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '註冊會員',
            item: url
          }
        ]
      }
    ]
  })
}
